const resource = '/v1/document-templates';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  },

  show(hashId) {
    return $axios.get(`${resource}/${hashId}`);
  },
});
